import throttle from 'lodash.throttle';

const aside = document.querySelector('.aside');

let init = () => {};

if (aside) {
    const asideToggleButton = aside.querySelector('.aside__toggle');
    const asideInner = aside.querySelector('.aside__inner');
    const content = document.querySelector('.content');

    const onAppearAnimationEnd = () => {
        asideInner.classList.remove('animated', 'slide_in_left');
        aside.removeEventListener('animationend', onAppearAnimationEnd);
    };

    const onDisappearAnimationEnd = () => {
        asideInner.classList.remove('animated', 'slide_out_left');
        aside.classList.remove('aside--showed');
        asideToggleButton.classList.remove('aside__toggle--close');
        aside.removeEventListener('animationend', onDisappearAnimationEnd);
    };

    const onScroll = () => {
        if (window.innerWidth <= 991) {
            if (window.pageYOffset > content.offsetTop) {
                asideToggleButton.classList.add('aside__toggle--visible');
            } else {
                asideToggleButton.classList.remove('aside__toggle--visible');
            }
        }
    };

    const onResize = () => {
        aside.style.bottom = '0px';

        if (asideInner.scrollHeight <= asideInner.offsetHeight) {
            aside.style.bottom = '';
        }
    };

    init = () => {
        onScroll();

        window.addEventListener('scroll', throttle(onScroll, 200));

        window.addEventListener('scroll', throttle(onResize, 200));

        asideToggleButton.addEventListener('click', () => {
            if (asideInner.classList.contains('animated')) {
                return;
            }

            if (!aside.classList.contains('aside--showed')) {
                asideInner.classList.add('animated', 'slide_in_left');
                aside.classList.add('aside--showed');
                asideToggleButton.classList.add('aside__toggle--close');

                aside.style.bottom = '0px';

                aside.addEventListener('animationend', onAppearAnimationEnd);

                if (asideInner.scrollHeight <= asideInner.offsetHeight) {
                    aside.style.bottom = '';
                }
            } else {
                asideInner.classList.add('animated', 'slide_out_left');

                aside.addEventListener('animationend', onDisappearAnimationEnd);
            }
        });
    };
}

export default init();
